import React from "react";
import { View, Text,  TouchableOpacity, Dimensions, StyleSheet,Icon  } from "react-native";
import Modal from 'react-modal';
import { Table, Row } from 'react-native-table-component';

const {width, height} = Dimensions.get('window');
const RCTTaskModal = ({showModal, handleCloseModal, pounchData, pounchHeader}) => {


    var tableHead =  ['#', 'Cust', 'Address', 'Arriv', 'Leave', 'Stay', 'Weight', 'Amount'];
    var widthArr = [33, 58, 94, 49, 49, 45, 60,64]; 
    var contentAddr = [236,214];
    return (
        <Modal
            style={{
                overlay: {
                    position: 'fixed',
                    top: width>640? height*0.1: height*0.2,
                    left: width>640? width*0.6 : 0,
                    right: width>640? width*0.3 : 0,
                    bottom: height*0.25,
                    width: width>640? width*0.3 : width*0.98,
                    height: height*0.7,
                    backgroundColor: 'rgba(255, 252, 140, 0.75)'
                },
                content: {
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                    right: '10px',
                    bottom: '10px',
                    border: '1px solid #ccc',
                    background: '#fff',
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    borderRadius: '4px',
                    outline: 'none',
                    padding: '20px'
                }
            }}
            isOpen={showModal}
        >   

            <View style={styles.contentContainer}>
                <View style={[styles.buttonContainer]}>
                        <TouchableOpacity 
                            onPress={handleCloseModal} 
                        >
                            <Text >X</Text>
                        </TouchableOpacity>
                </View>
                            <Table
                                style = {{marginTop:30}}
                                borderStyle={{
                                    borderWidth: 1,
                                    borderColor: '#EF9A19',
                                    marginTop:10
                                }}
                            >
                                <Row
                                    data={tableHead}
                                    widthArr={widthArr}
                                    style={{height: 30}}
                                    textStyle={{padding: 6, textAlign: 'center' }}
                                />
                                {pounchData.map((marker) => (
                                        <Row
                                            key={marker.id}
                                            data={[
                                                marker.id,
                                                marker.customer,
                                                marker.address.substring(0, marker.address.indexOf(",")),
                                                marker.startStopTime,
                                                marker.endStopTime,
                                                marker.stopseconds,
                                                marker.weight,
                                                marker.amount
                                            ]}
                                            widthArr={widthArr}
                                            style={[
                                                {height: 75}
                                            ]}
                                            textStyle={{padding: 6, textAlign: 'left' }}
                                        />
                                    ))}
                           
                          
                                {pounchHeader.map((marker, index) => (
                                        <Row
                                            key={index}
                                            data={[
                                                marker.name,
                                                marker.value
                                            ]}
                                            widthArr={contentAddr}
                                            style={[
                                                {height: 75}
                                            ]}
                                            textStyle={{padding: 6, textAlign: 'left' }}
                                        />
                                    ))
                                        }
                            </Table>
              
            </View>
        </Modal>
    )
}

const styles = StyleSheet.create({
    contentContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 10,
        position: 'absolute',
    },
    buttonContainer: {
        position: 'absolute',
        right: 5,
        top: 5,
    }

})

export default RCTTaskModal;